import React from 'react';
import { twMerge } from 'tailwind-merge';
var MessageWrapper = function (_a) {
    var isFirstMessage = _a.isFirstMessage, isFromUser = _a.isFromUser, children = _a.children;
    return (React.createElement("div", { className: twMerge('mt-3 max-w-104 px-6 py-4', isFirstMessage && 'mt-0', isFromUser
            ? 'ml-7.5 self-end rounded-bl-2xl rounded-br-none rounded-tl-2xl rounded-tr-2xl bg-chat-color font-normal leading-6 text-white'
            : 'mr-7.5 rounded-bl-none rounded-br-2xl rounded-tl-2xl rounded-tr-2xl bg-bot-light-gray font-normal leading-6 text-gray-700 mobile:mr-0') }, children));
};
export default MessageWrapper;
